import MediaType from "types/enums/MediaType";

const DEFAULT_ACCEPTED_MEDIA_TYPES = [
  MediaType.ImageGif,
  MediaType.ImageJpeg,
  MediaType.ImagePng,
  MediaType.VideoMp4,
];

export default DEFAULT_ACCEPTED_MEDIA_TYPES;
